export default "/app/themes/macleod/public/images/close-icon.svg?61eff203873c95f65c9445eade3203f2";